import { WO_API_PREFIX, REST_API_PREFIX, SF_API_PREFIX, SR_API_PREFIX, SC_API_PREFIX } from '@/config/common';
import { createAPI } from './http'
import axios from "axios";
import i18n from "@/i18n"
import store from '@/state/store';
import qs from "qs";
const api = createAPI();

/* 登录 */
// export function login(params) {
//     return api.post(WO_API_PREFIX + '/api/login', params)
// }

export function authStatus(redirect) {
    api.get(WO_API_PREFIX + '/api/auth/status', {}).then((res) => {
        let codes = JSON.stringify(res.payload.permission || [])
        let user = res.payload.user
        localStorage.setItem('user', JSON.stringify(user || {}))
        localStorage.setItem('permission', codes)
        store.commit('permission/setPermission', codes)
        if (redirect) {
            // if (user.user_type == 'customer') { // 客户角色默认跳转设备云图页面
            //     redirect = '/welcome'
            // } else if (!res.payload.permission.includes('service.get')) { // 判断没有服务请求页面权限的用户，跳工单页面
            //     if(user.user_type==='manufacturer'){
            //         redirect = '/auditing-order'
            //     }else{
            //         redirect = '/work-order'
            //     }
            // } else if(!res.payload.permission.length || res.payload.permission.length === 1) {
            //     redirect = '/unauthorized'
            // }
            // window.location.href = redirect
            //默认跳转云图页面
            window.location.href = '/welcome'
        }
    }).catch((err)=>{
        store.commit('notification/error', {"message": err.detail, "type": 401});
    });
}

export function workOrderList(params) {
    return api.get(WO_API_PREFIX + '/api/order', params)
}

export function workOrderDetail(id) {
    return api.get(`${WO_API_PREFIX}/api/order/${id}`)
}

export function createWorkOrder(params) {
    return api.post(WO_API_PREFIX + '/api/order', params)
}

export function editWorkOrder(params) {
    return api.patch(`${WO_API_PREFIX}/api/order/${params.id}`, params)
}
// 导出工单
export function exportWorkOrder(params) {
    return api.post(`${WO_API_PREFIX}/api/export/workorder`, params)
}
// 工单导出结果
export function exportWorkOrderResult(request_id) {
    return api.get(`${WO_API_PREFIX}/api/export/workorder?request_id=${request_id}`)
}
// 创建客户反馈
export function createCustomerFeedback(params) {
    return api.post(`${WO_API_PREFIX}/api/feedback`, params)
}

export function customers(params) {
    return api.get(WO_API_PREFIX + '/api/customer', params)
}
export function getCustomerOptions(params) {
    return api.get(WO_API_PREFIX + '/api/options/customer', params)
}
export function customerDetail(id) {
    return api.get(WO_API_PREFIX + '/api/customer/' + id)
}
export function deleteCustomer(id) {
    return api.delete(WO_API_PREFIX + '/api/customer/' + id)
}
export function postCustomer(params) {
    return api.post(WO_API_PREFIX + '/api/customer', params)
}
export function patchCustomer(params) {
    return api.patch(WO_API_PREFIX + '/api/customer/' + params.id, params)
}
export function company(params) {
    return api.get(WO_API_PREFIX + '/api/company', params)
}
export function serviceCompany(params) {
    return api.get(WO_API_PREFIX + '/api/service-company', params)
}
export function serviceCompanyDetail(id) {
    return api.get(WO_API_PREFIX + '/api/service-company/' + id)
}
export function createServiceCompany(params) {
    return api.post(WO_API_PREFIX + '/api/service-company', params)
}
export function patchServiceCompany(params) {
    return api.patch(WO_API_PREFIX + '/api/service-company/' + params.id, params)
}

export function deleteServiceCompany(id) {
    return api.delete(WO_API_PREFIX + '/api/service-company/' + id)
}
export function serviceReport(params) {
    return api.get(WO_API_PREFIX + '/api/report', params)
}

export function createServiceReport(params) {
    return api.post(WO_API_PREFIX + '/api/report', params)
}

export function deleteServiceReport(id) {
    return api.delete(WO_API_PREFIX + '/api/report/' + id)
}

// 报告导出
export function exportReport(report_id) {
    return api.post(WO_API_PREFIX + '/api/export/report', {
        report_id: report_id
    })
}

// 报告导出结果
export function exportReportDetail(request_id) {
    return api.get(WO_API_PREFIX + '/api/export/report?request_id=' + request_id)
}

export function getCompanyContacts(params) {
    return api.get(WO_API_PREFIX + '/api/company-contact', params)
}
export function postCompanyContact(params) {
    return api.post(WO_API_PREFIX + '/api/company-contact', params)
}
export function patchCompanyContact(params) {
    return api.patch(WO_API_PREFIX + '/api/company-contact/' + params.id, params)
}
export function deleteCompanyContact(id) {
    return api.delete(WO_API_PREFIX + '/api/company-contact/' + id)
}

export function getCompanyEngineers(params) {
    return api.get(WO_API_PREFIX + '/api/engineer', params)
}
export function postCompanyEngineer(params) {
    return api.post(WO_API_PREFIX + '/api/engineer', params)
}
export function patchCompanyEngineer(params) {
    return api.patch(WO_API_PREFIX + '/api/engineer/' + params.id, params)
}
export function deleteCompanyEngineer(id) {
    return api.delete(WO_API_PREFIX + '/api/engineer/' + id)
}

export function getCustomers(params) {
    return api.get(WO_API_PREFIX + '/api/customer', params)
}

export function getCustomerContacts(params) {
    return api.get(WO_API_PREFIX + '/api/customer-contact', params)
}
export function getCustomerContactDetail(id) {
    return api.get(WO_API_PREFIX + '/api/customer-contact/' + id)
}
export function postCustomerContact(params) {
    return api.post(WO_API_PREFIX + '/api/customer-contact', params)
}
export function patchCustomerContact(params) {
    return api.patch(WO_API_PREFIX + '/api/customer-contact/' + params.id, params)
}
export function deleteCustomerContact(id) {
    return api.delete(WO_API_PREFIX + '/api/customer-contact/' + id)
}

export function getCustomerContract(params) {
    return api.get(WO_API_PREFIX + '/api/contract', params)
}
export function getCustomerContractDetail(id) {
    return api.get(WO_API_PREFIX + '/api/contract/' + id)
}
export function postCustomerContract(params) {
    return api.post(WO_API_PREFIX + '/api/contract', params)
}
export function patchCustomerContract(params) {
    return api.patch(WO_API_PREFIX + '/api/contract/' + params.id, params)
}
export function deleteCustomerContract(id) {
    return api.delete(WO_API_PREFIX + '/api/contract/' + id)
}


export function engineer(params) {
    return api.get(WO_API_PREFIX + '/api/engineer', params)
}

export function checkin(params) {
    return api.get(WO_API_PREFIX + '/api/checkin', params)
}
export function addCheckin(params) {
    return api.post(WO_API_PREFIX + '/api/checkin', params)
}
export function editCheckin(params) {
    return api.patch(`${WO_API_PREFIX}/api/checkin/${params.id}`, params)
}
export function deleteCheckin(id) {
    return api.delete(`${WO_API_PREFIX}/api/checkin/${id}`)
}


/* 维修请求 */

export function getRepairList(params) {
    return api.get(WO_API_PREFIX + '/api/service', params)
}

export function getRepairDetail(id) {
    return api.get(WO_API_PREFIX + '/api/service/' + id)
}

export function postRepairService(params) {
    return api.post(WO_API_PREFIX + '/api/service', params)
}
/* 部分修改 */
export function patchRepairService(id, params) {
    return api.patch(WO_API_PREFIX + '/api/service/' + id, params)
}

export function deleteRepairService(id) {
    return api.delete(WO_API_PREFIX + '/api/service/' + id)
}

export function getCustomerList(params) {
    return api.get(WO_API_PREFIX + '/api/customer', params)
}

/* 施工现场 */
export function getSiteRecord(params) {
    return api.get(WO_API_PREFIX + '/api/site-record', params)
}
export function addSiteRecord(params) {
    return api.post(WO_API_PREFIX + '/api/site-record', params)
}

/* 现场情况说明 */
export function getSiteDescription(params) {
    return api.get(WO_API_PREFIX + '/api/site-description', params)
}
export function addSiteDescription(params) {
    return api.post(WO_API_PREFIX + '/api/site-description', params)
}

/* 服务商-企业资质 */
export function companyQualification(params) {
    return api.get(WO_API_PREFIX + '/api/company-qualification', params)
}
export function addCompanyQualification(params) {
    return api.post(WO_API_PREFIX + '/api/company-qualification', params)
}
export function patchCompanyQualification(params) {
    return api.patch(WO_API_PREFIX + '/api/company-qualification/' + params.id, params)
}
export function deleteCompanyQualification(id) {
    return api.delete(WO_API_PREFIX + '/api/company-qualification/' + id)
}

/* public:获取设备信息 */
export function publicDevices(params) {
    return api.get(`/${SF_API_PREFIX}/api/public/device`, params)
}
export function deviceSearch(params) {
    return api.get(`/${SF_API_PREFIX}/api/options/sn`, params)
}

//获取文件上传签名
export function getUploadFileSign(params) {
    return api.get('/' + REST_API_PREFIX + '/files/pre-signed', params)
}

//上传文件至指定url
export function putFiles(url, file, contentType) {
    return new Promise((resolve, reject) => {
        axios.put(url, file, { headers: { "Content-Type": contentType } }).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            if (err && err.response && err.response.status == 403) {
                const data = {
                    message: i18n.global.t('base.request403')
                }
                reject(data);
            } else {
                if (err.response && err.response.data && err.response.data.message) {
                    reject(err.response.data.message);
                } else {
                    reject(err.response && err.response.data && err.response.data.payload || err);
                }
            }
        });
    });

}
// 下载文件
export function downloadFile(url, contentType) {
    let filename = url.split('/').pop()
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
        let fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.download = filename;
        fileLink.click();
        URL.revokeObjectURL(fileLink.href)
    });

}

// 查询文件的详细数据
export function getUploadFileDetail(params) {
    return api.get('/' + REST_API_PREFIX + '/files/stat', params)
}

/* 创建文件 */
export function postUpdateFile(params) {
    return api.post(WO_API_PREFIX + '/api/file', params)
}

/* 查询文件内容 */
export function getFileDetail(params) {
    return api.get(WO_API_PREFIX + '/api/file', params)
}

// 删除文件
export function deleteFile(params) {
    return api.delete('/' + REST_API_PREFIX + '/files/remove', params)
}

//---------------------------------设备管理

//登录
export function login(params) {
    return api.post('/' + REST_API_PREFIX + '/auth/login', params)
}
//刷新token
export function reftoken(params) {
    return api.post('/' + REST_API_PREFIX + '/auth/refresh-token', params)
}
export function logout(params) {
    return api.delete('/' + REST_API_PREFIX + '/auth/logout', params)
}

// 模型
export function getModelDetails() {
    return api.get('/' + SF_API_PREFIX + '/api/models')
}
//模型详情
export function getModelDetailId(params) {
    return api.get('/' + SF_API_PREFIX + '/api/model/' + params.id)
}
//删除模型
export function deleteModelDetailId(params) {
    return api.delete('/' + SF_API_PREFIX + '/api/model/' + params.id)
}
/* 实例 */
export function getInstancesDetail(params) {
    return api.get('/' + SF_API_PREFIX + '/api/instances', params)
}
// 实例生命周期数据
export function getInstancesLifecycle(id) {
    return api.get('/' + SF_API_PREFIX + '/api/instance/life/' + id)
}
//删除实例
//删除模型
export function deleteInstancesDetailId(params) {
    return api.delete('/' + SF_API_PREFIX + '/api/instance/' + params.id)
}

///* 实例详情 */
export function getInstancesDetailId(params) {
    return api.get('/' + SF_API_PREFIX + '/api/instance/' + params.id,)
}
//
export function getInstancesTimeseries(id, params) {
    return api.get('/' + SF_API_PREFIX + '/api/instances/' + id + '/values/timeseries', params)
}
/* 二维码绑定 */
export function postBindQRCode(params) {
    return api.post('/' + SF_API_PREFIX + '/api/instances/bind-qrcode', params)
}
/* ----- 产品 ----- */

/* 模型树 */
export function getModelList(params) {
    return api.get('/' + SF_API_PREFIX + '/api/models/tree', params)
}
/* 新建产品 */
export function createModel(params) {
    return api.post('/' + SF_API_PREFIX + '/api/model', params)
}
/* 修改产品 */
export function putModel(id, params) {
    return api.put(`/${SF_API_PREFIX}/api/model/${id}`, params)
}

/* 修改实例Flag */
export function editModelFlag(id, params) {
    return api.put('/' + SF_API_PREFIX + '/api/model/flag/' + id, params)
}

/* ----- 物实例 ----- */

/* 修改实例Flag */
export function editInstanceFlag(id, params) {
    return api.put('/' + SF_API_PREFIX + '/api/instances/flag/' + id, params)
}

/* 新建物实例 */
export function createInstance(params) {
    return api.post('/' + SF_API_PREFIX + '/api/instance', params)
}

/* 修改物实例 */
export function editInstance(id, params) {
    return api.put(`/${SF_API_PREFIX}/api/instance/${id}`, params)
}

/* 获取物实例详情 */
export function getInstanceDetail(id, params) {
    return api.get(`/${SF_API_PREFIX}/api/instance/${id}`, params)
}

/* 获取物实例详情完整层级树 */
export function getInstanceDetailTree(id, params) {
    return api.get(`/${SF_API_PREFIX}/api/instance/${id}?is_tree_table=` + params.is_tree_table)
}

/* 获取产品列表 */
export function getModelsList() {
    return api.get('/' + SF_API_PREFIX + '/api/models')
}

/* 获取物实例列表 */
export function getInstancesList(params) {
    if (params) {
        return api.get('/' + SF_API_PREFIX + '/api/instances', params)
    } else {
        return api.get('/' + SF_API_PREFIX + '/api/instances')
    }
}


/* 导出测量值列表 */
export function exportInstancesMeasurements() {
    return api.get('/' + SF_API_PREFIX + '/api/instances/measurements')
}

//设备列表
export function devicesTables() {
    return api.get('/' + SF_API_PREFIX + '/api/devices')
}

/* start----------- 事件管理 -------------start */
//获取事件列表
export function getEventsList(params) {
    const formData = new FormData();
    Object.keys(qs.parse(params)).forEach(key => {
        const value = qs.parse(params)[key];
        if (Array.isArray(value)) {
        value.forEach((subValue) => {
            formData.append(key , subValue);
        });
        } else {
        formData.append(key, value);
        }
    });
    return api.post(`/${REST_API_PREFIX}/events`,formData)
}
//获取事件详情
export function getEventsDetail(eventId, params) {
    return api.get(`/${REST_API_PREFIX}/events/${eventId}`, params)
}
//修改事件基本信息
export function putEventBasicInfo(eventId, params) {
    return api.put(`/${REST_API_PREFIX}/events/${eventId}/info`, params)
}
//事件添加附件
export function putEventAttach(eventId, params) {
    return api.put(`/${REST_API_PREFIX}/events/${eventId}/attachments`, params)
}
//获取相关事件
export function getEventsRelated(params) {
    return api.get(`/${REST_API_PREFIX}/events/related`, params)
}
//获取事件报告
export function getEventsReport(params) {
    return api.get(`/${REST_API_PREFIX}/reports`, params)
}
/* end ---------------事件管理-------------- end */


/* start----------- 阈值工艺管理 -------------start */
//修改实例测量值静态阈值
export function putMeasureStaticThres(id, params) {
    return api.put(`/${SF_API_PREFIX}/api/instances/measurements/${id}`, params)
}
//修改实例测量值静态阈值状态
export function putMeasureStaticThresStat(id, params) {
    return api.put(`/${SF_API_PREFIX}/api/instances/measurements/status/${id}`, params)
}
//修改实例测量值专家建议
export function putMeasureExpertSugg(id, params) {
    return api.post(`/${SF_API_PREFIX}/api/instances/measurements/info/${id}`, params)
}
/* end----------- 阈值工艺管理 -------------end */


//健康监控
//图表数据
export function getWindowTimeseries(id, params,callback) {
    return api.get(`/${REST_API_PREFIX}/telemetry/timeseries/${id}/window-query?${params}`,{},{},callback)
}
//测量值原始值
export function getRawTimeseries(id, params) {
    return api.get(`/${REST_API_PREFIX}/telemetry/timeseries/${id}/raw-query?${params}`)
}
//测量值当前值
export function getLatestTimeseries(id) {
    return api.get('/' + REST_API_PREFIX + '/telemetry/timeseries/' + id + '/latest')
}
//图表注释
export function setLatestReports(params) {
    return api.post('/' + REST_API_PREFIX + '/reports', params)
}
export function getLatestReports(params) {
    return api.get('/' + REST_API_PREFIX + '/reports', params)
}
export function delLatestReports(id) {
    return api.delete('/' + REST_API_PREFIX + '/reports/' + id)
}
export function putLatestReports(id, params) {
    return api.put(`/${REST_API_PREFIX}/reports/${id}`, params)
}
export function getInstancesTree(params) {
    return api.get(`/${SF_API_PREFIX}/api/instance/tree`, params)
}

/* 维护保养信息 */
//创建设备保养任务
export function createMaintenTasks(params) {
    return api.post('/' + SC_API_PREFIX + '/api/tasks', params)
}
//获取设备保养列表
export function getMaintenTasks(params) {
    return api.get('/' + SC_API_PREFIX + '/api/tasks', params)
}
//修改设备保养任务
export function editMaintenTasks(id, params) {
    return api.put('/' + SC_API_PREFIX + '/api/tasks/' + id, params)
}
//删除设备保养任务
export function deleteMaintenTasks(id, params) {
    return api.delete('/' + SC_API_PREFIX + '/api/tasks/' + id, params)
}
//查询设备保养任务完成状态
export function getMaintenTaskStatus(params) {
    return api.get('/' + SC_API_PREFIX + '/api/task-status', params)
}
//更新设备保养任务状态
export function updateMaintenTaskStatus(id, params) {
    return api.put('/' + SC_API_PREFIX + '/api/task-status/' + id, params)
}


//创建设备维护任务
export function createRepairTasks(params) {
    return api.post('/' + SR_API_PREFIX + '/api/equipment-repair', params)
}
//获取设备维护列表
export function getRepairTasks(params) {
    return api.get('/' + SR_API_PREFIX + '/api/equipment-repair', params)
}
//修改设备维护任务
export function editRepairTasks(id, params) {
    return api.put('/' + SR_API_PREFIX + '/api/equipment-repair/' + id, params)
}
//删除设备维护任务
export function deleteRepairTasks(id, params) {
    return api.delete('/' + SR_API_PREFIX + '/api/equipment-repair/' + id, params)
}


//动态阈值
export function putDynamicStat(id, params) {
    return api.put(`/${SF_API_PREFIX}/api/instances/dynamic-threshold/status/${id}`, params)
}
// //动态阈值详情
// export function getDynamicEvent(params) {
//     return api.get('/' + REST_API_PREFIX + '/event/definition/'+params.id)
// }
// //动态阈值列表
export function getDynamicEventId() {
    return api.get('/' + REST_API_PREFIX + '/event/definition')
}

// export function getTelemetryPersistence(params) {
//     return api.get('/' + REST_API_PREFIX + '/telemetry/persistence/'+params.id)
// }

// //设置动态阈值
// export function postTelemetryPersistence(params) {
//     return api.post(`/${REST_API_PREFIX}/telemetry/persistence/${params.database}/${params.model}/column/`+params)
// }


// 组织账号管理
export function getOrganizationAccounts(params) {
    return api.get(WO_API_PREFIX + '/api/admin/account', params)
}
export function organizationAccountDetail(id) {
    return api.get(WO_API_PREFIX + '/api/admin/account/' + id)
}
export function createOrganizationAccount(params) {
    return api.post(WO_API_PREFIX + '/api/admin/account', params)
}
export function patchOrganizationAccount(params) {
    return api.patch(WO_API_PREFIX + '/api/admin/account/' + params.id, params)
}

export function deleteOrganizationAccount(id) {
    return api.delete(WO_API_PREFIX + '/api/admin/account/' + id)
}
// 用户账号管理
export function getUserAccounts(params) {
    return api.get(WO_API_PREFIX + '/api/internal/account', params)
}
export function userAccountDetail(id) {
    return api.get(WO_API_PREFIX + '/api/internal/account/' + id)
}
export function createUserAccount(params) {
    return api.post(WO_API_PREFIX + '/api/internal/account', params)
}
export function patchUserAccount(params) {
    return api.patch(WO_API_PREFIX + '/api/internal/account/' + params.id, params)
}
export function resetPassword(user_id) {
    return api.post(WO_API_PREFIX + '/api/account/reset-password', {user: user_id})
}

export function deleteUserAccount(id) {
    return api.delete(WO_API_PREFIX + '/api/internal/account/' + id)
}
// 国家 省份 市
export function country(params) {
    return api.get(WO_API_PREFIX + '/api/data/country', params)
}
export function province(params) {
    return api.get(WO_API_PREFIX + '/api/data/province', params)
}
export function city(params) {
    return api.get(WO_API_PREFIX + '/api/data/city', params)
}
// 个人信息
export function userProfile() {
    return api.get(WO_API_PREFIX + '/api/user-profile')
}
export function patchUserProfile(params) {
    return api.patch(WO_API_PREFIX + '/api/user-profile/' + params.id, params)
}
// 设备制造商列表
export function getManufacturers(params) {
    return api.get(WO_API_PREFIX + '/api/manufacturer', params)
}
// 设备制造商详情
export function getManufacturerDetail(id) {
    return api.get(WO_API_PREFIX + '/api/manufacturer/' + id)
}
export function patchManufacturer(params) {
    return api.patch(WO_API_PREFIX + '/api/manufacturer/' + params.id, params)
}
// 角色
export function roleList(params) {
    return api.get(WO_API_PREFIX + '/api/rbac/role', params)
}
export function postRole(params) {
    return api.post(WO_API_PREFIX + '/api/rbac/role', params)
}
export function patchRole(params) {
    return api.patch(WO_API_PREFIX + '/api/rbac/role/' + params.id, params)
}
export function deleteRole(id) {
    return api.delete(WO_API_PREFIX + '/api/rbac/role/' + id)
}
// 获取权限树
export function getPermissionTree(roleId) {
    return api.get(WO_API_PREFIX + '/api/rbac/permission-tree', { role: roleId })
}
// 修改角色权限
export function patchRolePermission(params) {
    return api.post(WO_API_PREFIX + '/api/rbac/authorize', params)
}
// 个人中心企业信息
export function getCompanyInfo() {
    return api.get(WO_API_PREFIX + '/api/account/company')
}
// 商业伙伴角色列表
export function getPartnerRoles(type) {
    return api.get(WO_API_PREFIX + '/api/admin/role', { role: type })
}
// 商业伙伴获取权限树
export function getPartnerPermissionTree(roleId) {
    return api.get(WO_API_PREFIX + '/api/admin/permission-tree', { role: roleId })
}
// 商业伙伴角色授权
export function patchPartnerRolePermission(params) {
    return api.post(WO_API_PREFIX + '/api/admin/authorize', params)
}
// 商机列表
export function getOpportunities(params) {
    return api.get(WO_API_PREFIX + '/api/task', params)
}
// 修改商机
export function patchOpportunity(params) {
    return api.patch(WO_API_PREFIX + '/api/task/' + params.id, params)
}
// 导出商机
export function exportOpportunities(params) {
    return api.post(`${WO_API_PREFIX}/api/export/task`, params)
}
// 工单导出结果
export function exportOpportunityResult(request_id) {
    return api.get(`${WO_API_PREFIX}/api/export/task?request_id=${request_id}`)
}
// 商机评论列表
export function getOpportunityComments(params) {
    return api.get(WO_API_PREFIX + '/api/task-comment', params)
}
// 创建商机评论
export function postOpportunityComment(params) {
    return api.post(WO_API_PREFIX + '/api/task-comment', params)
}
// 获取商机设备类型
export function getOpportunityDeviceTypes() {
    return api.get(WO_API_PREFIX + '/api/options/task-device-type')
}
// 体检详情
export function getReportLatest(id) {
    return api.get('/' + SF_API_PREFIX + '/api/report/'+id)
}
// 体检报告列表

export function getReportList(params) {
    return api.get('/' + SF_API_PREFIX + '/api/report',params)
}
// 生成体检报告
export function postReportLatest(params) {
    return api.post('/' + SF_API_PREFIX + '/api/report',params)
}
// 模型关联设备
export function getModelDevices(params) {
    return api.get(`/${SF_API_PREFIX}/api/model/relation-instance/${params.model_id}`, params)
}
// 通知列表
export function getNotifications(params) {
    return api.get(WO_API_PREFIX + '/api/notifications', params)
}
// 通知标记为已读
export function notificationRead(id) {
    return api.post(WO_API_PREFIX + '/api/notifications/mark-as-read', { id: id })
}
// 标记所有通知已读
export function notificationAllRead() {
    return api.post(WO_API_PREFIX + '/api/notifications/mark-all-as-read')
}
// 未读通知数量
export function notificationUnreadCount() {
    return api.get(WO_API_PREFIX + '/api/notifications/unread_count')
}
// 行业统计
export function overviewIndustry(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/industry',params)
}
//设备状态

export function overviewDeviceStatus(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/device-status',params)
}

//产品类型

export function overviewProductType(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/product-type',params)
}
//省级设备统计
export function overviewSite(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/overview/site',params)
}
//省级设备统计
export function overviewSiteCustomer(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/overview/site-customer',params)
}
//全国lot状态
export function overviewSiteDevice(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/overview/site-device',params)
}
//全国总量
export function overviewOrderStatus(params) {
    return api.post('/' + WO_API_PREFIX + '/api/dashboard/overview-order-status',params)
}
//全国负荷
export function overviewWorkload(params) {
    return api.post('/' + WO_API_PREFIX + '/api/dashboard/overview-workload',params)
}

//工单统计

export function overviewWorkOrder(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/work-order',params)
}
//服务与商机

export function overviewService(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/service-and-task',params)
}
//商机丢失原因
 
export function overviewTaskLostReason(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/overview/task-lost-reason',params)
}

//统计数据
//服务请求

export function statisticsServiceRequest(params) {
    return api.get('/'+WO_API_PREFIX+'/api/statistics/service-request',params)
}
//工单
export function statisticsOrder(params) {
    return api.get('/'+WO_API_PREFIX+'/api/statistics/order',params)
}
//auditing工单
export function auditingList(params) {
    return api.get('/'+WO_API_PREFIX+'/api/auditing',params)
}
//工单详情
export function auditingDetails(id) {
    return api.get('/'+WO_API_PREFIX+'/api/auditing/'+id)
}
//工单修改
export function putAuditingDetails(id,params) {
    return api.patch('/'+WO_API_PREFIX+'/api/auditing/'+id,params)
}
//派工信息
export function auditingAssign(id) {
    return api.get('/'+WO_API_PREFIX+'/api/auditing-assign/'+id)
}
//派工信息
export function postAuditingAssign(params) {
    return api.post('/'+WO_API_PREFIX+'/api/auditing-assign',params)
}
//原厂工程师列表
export function auditingEngineer(params) {
    return api.get('/'+WO_API_PREFIX+'/api/auditing-engineer',params)
}
//商机
export function statisticsBusiness(params) {
    return api.get('/'+WO_API_PREFIX+'/api/statistics/business',params)
}
//保养计划
export function statisticsPlan(params) {
    return api.get('/'+WO_API_PREFIX+'/api/statistics/plan',params)
}
//设备统计

export function instancesStatistics(params) {
    return api.get('/' + SF_API_PREFIX + '/api/instances/statistics',params)
}

//应用行业型号统计
export function deviceProductIndustry(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/device/product-industry',params)
}
//设备类型统计
export function deviceProduct(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/device/product',params)
}
//增长率、同比、环比
export function deviceGrowthRate(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/device/growth-rate',params)
}
//应用行业产品分类
export function deviceIndustryProduct(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/device/industry-product',params)
}

//装机量
export function deviceInstalled(params) {
    return api.get('/' + SF_API_PREFIX + '/api/dashboard/device/installed',params)
}
//同比环比
export function orderGrowthRate(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/growth-rate',params)
}

//工单状态统计

export function orderStatus(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/order-status',params)
}
//状态分析
export function orderStatusAnalysis(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/order-status-analysis',params)
}
//报告类型
export function reportType(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/report-type',params)
}
//工单反馈情况

export function orderFeedback(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/order-feedback',params)
}
//工单行业统计
export function orderIndustry(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/order-industry',params)
}

// 商机-桑基图数据
export function getChannels(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/channels',params)
}

// 商机-排行榜数据
export function getRanking(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/realisation-variance-ranking',params)
}

// 商机-地图-排行榜数据
export function getSiteRanking(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/site-ranking',params)
}

//客户
export function instanceApi(params) {
    return api.get('/' + SF_API_PREFIX + '/api/customer/instance',params)
}

//客户
export function instanceName(params,id) {
    return api.put('/' + SF_API_PREFIX + '/api/instance/name/'+id,params)
}


//工单类型
export function orderType(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/order-type',params)
}
//http://52.83.189.182:18080/oodt/api/dashboard/device/amount-trend
export function amountTrend(params) {
    return api.post('/' + SF_API_PREFIX + '/api/dashboard/device/amount-trend',params)
}
//http://52.83.189.182:18080/wo/api/dashboard/monthly-workload?start=&end=
export function monthlyWorkload(params) {
    return api.get('/' + WO_API_PREFIX + '/api/dashboard/monthly-workload',params)
}


//收藏图片模型 
export function documentCollection(params) {
    return api.post('/' + SF_API_PREFIX + '/api/instance/document/collection', params)
}

//获取设备导入模版文件URL 
export function getDeviceImportTemplateUrl() {
    return api.get('/' + SF_API_PREFIX + '/api/import/device/template')
}

//能耗管理

export function instancesSetting(key) {
    return api.get('/' + SF_API_PREFIX + '/api/instances/setting/'+key)
}
export function setInstancesSetting(params) {
    return api.post('/' + SF_API_PREFIX + '/api/instances/setting',params)
}

//年度数据
export function energyAnnual(params) {
    return api.get('/' + SF_API_PREFIX + '/api/energy/annual',params)
}
//月度数据
export function energyMonthly(params) {
    return api.get('/' + SF_API_PREFIX + '/api/energy/monthly',params)
}

/*联系人-----------------------------------------------------------------------------------------------------------------*/
//联系人列表
export function getAuditingDetail(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/detail',params)
}
//添加联系人
export function postAuditingDetail(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/detail',params)
}
//修改时间
export function patchAuditingDetail(id,params) {
    return api.patch('/' + WO_API_PREFIX + '/api/auditing/detail/'+id,params)
}
//删除联系人
export function deleteAuditingDetail(id) {
    return api.delete('/' + WO_API_PREFIX + '/api/auditing/detail/'+id)
}

/*设备-------------------------------------------------------------------------------------------------------------------*/
//测点列表
export function getAuditingDeviceMeasurement(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/device-measurement',params)
}
//保存测点数据
export function postAuditingDeviceMeasurement(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/device-measurement',params)
}
//设备列表
export function getAuditingDevice(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/device',params)
}
//设备列表tree 
export function getAuditingDeviceTree(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/device-tree',params)
}
//添加设备
export function postAuditingDevice(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/device',params)
}
//修改时间
export function patchAuditingDevice(id,params) {
    return api.patch('/' + WO_API_PREFIX + '/api/auditing/device/'+id,params)
}
//删除设备
export function deleteAuditingDevice(id) {
    return api.delete('/' + WO_API_PREFIX + '/api/auditing/device/'+id)
}

/*诊断记录----------------------------------------------------------------------------------------------------------------*/
//诊断记录列表
export function getAuditingDiagnosis(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/diagnosis',params)
}
//删除诊断记录
export function deleteAuditingDiagnosis(id) {
    return api.delete('/' + WO_API_PREFIX + '/api/auditing/diagnosis/'+id)
}
//保存诊断记录
export function postAuditingDiagnosis(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/diagnosis',params)
}
//故障一级列表
export function getFaultKnowledgeBase(params) {
    return api.get('/' + WO_API_PREFIX + '/api/fault-knowledge-base',params)
}
//故障二级列表
export function getFaultKnowledgeBaseSolution(params) {
    return api.get('/' + WO_API_PREFIX + '/api/fault-knowledge-base-solution',params)
}

/*服务建议----------------------------------------------------------------------------------------------------------------*/
//诊断服务建议列表
export function getAuditingService(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/service',params)
}

//删除服务建议
export function deleteAuditingService(id) {
    return api.delete('/' + WO_API_PREFIX + '/api/auditing/service/'+id)
}
//保存服务建议
export function postAuditingService(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/service',params)
}
//维修包一级列表
export function getRepairKit(params) {
    return api.get('/' + WO_API_PREFIX + '/api/repair-kit',params)
}
//维修包二级列表
export function getRepairKitComponent(params) {
    return api.get('/' + WO_API_PREFIX + '/api/repair-kit-component',params)
}

/*商机转换----------------------------------------------------------------------------------------------------------------*/
//商机转换
export function getAuditingConvert(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/convert',params)
}
//商机转换
export function postAuditingConvert(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/convert',params)
}

/*审核----------------------------------------------------------------------------------------------------------------*/
//提交审核
export function postAuditingApproval(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/approval',params)
}
//审核
export function postAuditingReview(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/review',params)
}

/*服务报告----------------------------------------------------------------------------------------------------------------*/
export function getAuditingReport(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/report',params)
}
//服务报告详情
export function getAuditingReportDetail(id) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/report/'+id)
}

//日志
export function getAuditingLog(params) {
    return api.get('/' + WO_API_PREFIX + '/api/auditing/log',params)
}

//销售工程师
export function getAuditingChangeOwner(id,params) {
    return api.put('/' + WO_API_PREFIX + '/api/auditing/change-owner/'+id,params)
}

//服务回访导出
export function feedbackExport(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/feedback-export',params)
}
//服务回访导出结果

export function getFeedbackExport(request_id) {
    return api.get(`${WO_API_PREFIX}/api/auditing/feedback-export?request_id=${request_id}`)
}

//导入
export function feedbackImport(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/feedback-import',params)
}

//auditing信息
export function statisticsAuditing() {
    return api.get('/' + WO_API_PREFIX + '/api/statistics/auditing')
}

//设备联系人修改
export function instanceAttribute(id,params) {
    return api.put('/' + SF_API_PREFIX + '/api/instance/attribute/'+id,params)
}

//销售工程师列表

export function saleEngineer(params) {
    return api.get('/' + WO_API_PREFIX + '/api/sale-engineer',params)
}

//服务评分
export function auditingRating(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/rating',params)
}

// 服务地区-省列表
export function serviceAreaProvince(params) {
    return api.get(WO_API_PREFIX + '/api/service-area/province', params)
}

//签到
export function auditingCheckin(params) {
    return api.post('/' + WO_API_PREFIX + '/api/auditing/checkin',params)
}

//工单附件
export function auditingAttachment(id, detailId) {
    return api.get(WO_API_PREFIX + '/api/auditing/attachment/' + id, {
        detail:detailId
    })
}

//客户设备保养项目
export function deviceMaintainItem(id) {
    return api.get('/' + WO_API_PREFIX + '/api/order/device-maintain-item/'+id)
}

//年度同比数据
export function energyYoyData(params) {
    return api.get('/' + SF_API_PREFIX + '/api/energy/yoy-data', params)
}

//普通工单联系人调整

export function postCustomerDeviceContact(params) {
    return api.post('/' + WO_API_PREFIX + '/api/customer-device-contact', params)
}
export function putCustomerDeviceContact(id, params) {
    return api.put('/' + WO_API_PREFIX + '/api/customer-device-contact/'+id, params)
}
//详情
export function getCustomerDeviceContact(id) {
    return api.get('/' + WO_API_PREFIX + '/api/customer-device-contact/'+id)
}

//能耗
export function getEnergyConfig(id) {
    return api.get('/' + SF_API_PREFIX + '/api/energy/config/'+id)
}
export function postEnergyConfig(id,params) {
    return api.post('/' + SF_API_PREFIX + '/api/energy/config/'+id,params)
}
